import { defineComponent as _defineComponent } from 'vue'
import AccoutHeader from '../AccoutHeader/AccoutHeader.vue'
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch.vue'
import CloseAlarmLamp from '@/views/configureManagement/alarmLampCreateEdit/popup/CloseAlarmLamp/CloseAlarmLamp.vue'
import TopMenu from '../TopMenu/TopMenu.vue';
import ThemeSwitch from '../ThemeSwitch.vue'
import { platformDataValue, platformImageUrl } from '@/view_helper/platform'
import { autoLogin } from '@/utils/global'
import { IMenuItem } from '@/view_helper/mainMenu'
import { useDialog } from '@/hooks/useDialog';
import { useStore } from '@/hooks/useStore';
import { computed, getCurrentInstance } from 'vue';
import { isManYiDianZiWork } from '@/custom/manyidianzi';
import { isHeibeiGuangHeDongLi } from '@/custom/ghdl';
import { isNJANDKJ } from '@/custom/NJANDKJ';
import { useRoute } from 'vue-router/composables';
import { E_RouterNames } from '@/router/types';
import { useI18n } from '@/hooks/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainTitle',
  props: {
    menus: null
  },
  setup(__props: any) {

const props = __props as {
    menus: IMenuItem[]    
}

const instance = getCurrentInstance()
const route = useRoute()
const isPlatformPortal = computed(() => route.name === E_RouterNames.platformPortal)
const { $t } = useI18n()



const {
    store
} = useStore()

const isSuperAdmin = computed(() => {
    return store.getters.isSuperAdmin
})

const {
    showDialog: showAlarmLamp,
    onCloseDialog: onAlarmLampClose,
    onShowDialog: onClickAlarmLamp
} = useDialog()

const urls = computed(() => {
    const LogoUrl =  platformImageUrl(instance.proxy, 'logo', false)
    const PlatformUrl = platformImageUrl(instance.proxy, 'platform', false)

    const companyLogoUrlRaw = platformImageUrl(instance.proxy, 'companyLogo', false)
    const companyLogoUrl = platformImageUrl(instance.proxy, 'companyLogo', true)
    let systemCompanyName = isPlatformPortal.value
        ? $t('platformPortal.headerTitle') as string
        : platformDataValue<string>(instance.proxy, 'systemCompanyName')
    const hasNew = companyLogoUrlRaw && systemCompanyName
    const useLegacy = !(hasNew) && (LogoUrl || PlatformUrl)
    const tinyComanyNameSize = (systemCompanyName || '').length > 14

    const companyLogoStatus = platformDataValue(instance.proxy, 'companyLogoStatus')
    const LogoUrlUse = platformImageUrl(instance.proxy, 'logo', true)
    const PlatformUrlUse = platformImageUrl(instance.proxy, 'platform', true)    

    return {
        useLegacy,

        LogoUrl: LogoUrlUse,
        PlatformUrl: PlatformUrlUse,

        companyLogoUrl,
        tinyComanyNameSize,
        systemCompanyName,
        companyLogoStatus,
    }
})

const showLogo = computed(() =>!isManYiDianZiWork(instance.proxy.$store) && !isHeibeiGuangHeDongLi(instance.proxy.$store))
const largeLogo = computed(() => isNJANDKJ(instance.proxy.$store))


return { __sfc: true,instance, route, isPlatformPortal, $t, props, store, isSuperAdmin, showAlarmLamp, onAlarmLampClose, onClickAlarmLamp, urls, showLogo, largeLogo, AccoutHeader, LanguageSwitch, CloseAlarmLamp, TopMenu, ThemeSwitch, autoLogin }
}

})